<style lang="sass">
</style>


<template>
<div class="reservation-filter">
  <div class="form-group">
    <checkbox-group :values.sync="displayStatuses">
      <checkbox-button :value="5">キャンセル</checkbox-button>
      <checkbox-button :value="6">来店なし</checkbox-button>
      <checkbox-button :value="-1">削除済み</checkbox-button>
    </checkbox-group>
  </div>
</div>
</template>


<script>
import moment from 'moment'

export default {
  name: 'reservation-filter',
  props: {
    displayStatuses: {
      type: Array,
      twoWay: true,
      default: [],
    },
  },
  methods: {
    toToday() {
      this.date = moment().startOf('day').format('YYYY-MM-DD')
    },
    addDays(n) {
      this.date = moment(this.date).add(n, 'days').format('YYYY-MM-DD')
    }
  },
  components: {
    checkboxGroup: require('ui/checkbox-group.vue'),
    checkboxButton: require('ui/checkbox-button.vue'),
  },
}
</script>



// WEBPACK FOOTER //
// reservation-filter.vue?e12c6bec